window.addEventListener('PandectesEvent_OnConsent', function(event) {
    if (event.detail.consentType === 'default') {
        checkCookie();
    }
});

window.addEventListener('PandectesEvent_OnConsent', function(event) {
    if (event.detail.consentType === 'new' || event.detail.consentType === 'stored') {
        if ((event.detail.preferences & 1) === 0) {
            insertCookie(true);
        }else{
            setCookie('rlx-consent','false',30);
        }
    }
});

function checkCookie(){
    let user = getCookie("ie-consent");
    if(user != ""){
        setCookie('rlx-consent',getCookie("rlx-consent"),30);
        return false;
    } else {
        setCookie('rlx-consent','false',30);
        jQuery('.ie-cookie-main .ie-cookie-wrapper').toggleClass('show');
        return true;
    }
}
function setCookie(cname,cvalue,exdays){
    const d = new Date();
    d.setTime(d.getTime() +(exdays*24*60*60*1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname){
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++){
      let c = ca[i];
      while(c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if(c.indexOf(name) == 0){
        return c.substring(name.length, c.length);
      }
    }
    return "";
}
function insertCookie(consent){
    var acceptance = 'rlx-consent';
     if(consent == true || consent == 'true'){
        setCookie('rlx-consent','true',30);
        setCookie('ie-consent','true',30);
    }else{
        setCookie('rlx-consent','false',30);
        setCookie('ie-consent','false',30);
    }

}

/**
 * Footer "Cookie Preferences" link - reopens the Pandectes consent banner.
 * Replaces the app's floating shield button, which is hidden via CSS (.cc-revoke).
 */
document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger) {
        return;
    }

    event.preventDefault();
    showConsentBanner();
});

function showConsentBanner(attempt) {
    var tries = attempt || 0;

    if (window.Pandectes && window.Pandectes.fn && typeof window.Pandectes.fn.showBanner === 'function') {
        window.Pandectes.fn.showBanner();
        return;
    }

    // The app script may still be loading on an early click - retry for up to ~3s.
    if (tries < 30) {
        setTimeout(function () {
            showConsentBanner(tries + 1);
        }, 100);
    }
}
